import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {DeviceType} from '../../../../../../incase-domain/common/DeviceType.enum';
import Button from '../../../../../../incase-domain/components/button/Button';
import DropdownMenuCompact, {
    DropdownMenuCompactRef,
} from '../../../../../../incase-domain/components/dropdownMenuCompact/DropdownMenuCompact';
import {switchGridAction} from '../../../../../../store/actions/grid';
import {setSelectedView} from '../../../../../../store/actions/presentation';
import {showGridSelector} from '../../../../../../store/selectors/grid';
import {selectedSlideDeviceTypeSelector} from '../../../../../../store/selectors/slide.selectors';

type MenuBarViewDropdownProps = {
    viewMenuItemRef: React.RefObject<DropdownMenuCompactRef>;
    menuBarOpen: boolean;
    onHoverEnter: () => void;
    onMenuClose: () => void;
    onOpenMenuBar: () => void;
};

function MenuBarViewDropdown({
    viewMenuItemRef,
    menuBarOpen,
    onHoverEnter,
    onMenuClose,
    onOpenMenuBar,
}: MenuBarViewDropdownProps): JSX.Element {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const slideDeviceType = useSelector(selectedSlideDeviceTypeSelector);
    const showGrid = useSelector(showGridSelector);

    const viewMenuItems = useMemo(
        () => [
            [
                {
                    label: t('menuBar.viewMenu.desktop'),
                    icon: 'solar:display-linear',
                    disabled: slideDeviceType === DeviceType.MOBILE,
                    onClick: () => dispatch(setSelectedView(DeviceType.DESKTOP)),
                },
                {
                    label: t('menuBar.viewMenu.mobile'),
                    icon: 'solar:smartphone-linear',
                    disabled: slideDeviceType === DeviceType.DESKTOP,
                    onClick: () => dispatch(setSelectedView(DeviceType.MOBILE)),
                },
            ],
            [
                {
                    label: t('menuBar.viewMenu.grid'),
                    active: showGrid,
                    icon: 'solar:ruler-linear',
                    onClick: () => {
                        dispatch(switchGridAction());
                    },
                },
            ],
        ],
        [t, slideDeviceType, dispatch, showGrid]
    );

    return (
        <DropdownMenuCompact
            ref={viewMenuItemRef}
            openOnMouseEnter={menuBarOpen}
            onHoverEnter={onHoverEnter}
            onMenuClose={onMenuClose}
            items={viewMenuItems}
        >
            <Button size="2xs" disableHover square variant="ghost" className="c-menuBar__button" onClick={onOpenMenuBar}>
                {t('menuBar.view')}
            </Button>
        </DropdownMenuCompact>
    );
}

export default React.memo(MenuBarViewDropdown);
